<template>
  <footer class="footer mt-auto print:!hidden">
    <FooterUpperFooter />
    <FooterLowerFooter />
  </footer>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>

<style lang="scss">
  body:has(.page--vehicle-detail) footer.footer {
    @apply print:hidden;
  }
</style>